import * as moment from 'moment';
import * as _ from 'lodash';
import * as $ from 'jquery';

import { Component, OnInit, ViewChild, ElementRef, HostListener, AfterViewInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router';
import { ScheduleModule, CalendarModule, DialogModule, Message } from 'primeng/primeng'
// Models
import {
    StudentList, Student, StudentFilter, CampusFullItem, YearGroup,
    YearGroupWithGradeClasses, gradeClass, StudentImportResult
} from '../../../common/modules/core/models';
// Services
import { StudentService, SessionStorageService, CatalogService } from '../../../common/modules/core/services';
import { BusServices } from '../../services/BusServices';
import { ChildrenServices } from '../../services/ChildrenServices';

@Component({
    template: require('./BusAttendanceComponent.html'),
    styles: [require('./BusAttendanceComponent.sass')]
})

export class BusAttendanceComponent implements OnInit, AfterViewInit {
    private children: any
    private startWeek: string
    private endWeek: string
    private events: any = []
    private scheduleHeaderConfig: any
    private currentId: string
    private studentInfo: Student
    private studentSchedule: any = []
    // Event click
    private showScheduleDialog: boolean = false
    private selectedEvent: any
    // Subscription
    private sub: any
    viewType: any;
    //map
    isViewMap: boolean = false;
    studentLocation: any;
    planningInfo: any;

    isShowSchedule: boolean = true;

    constructor(
        private services: BusServices,
        private childrenServices: ChildrenServices,
        private route: ActivatedRoute,
        private elementRef: ElementRef,
    ) {
        this.planningInfo = { header: '' };
        // Schedule header config
        this.scheduleHeaderConfig = {
            left: 'prev,next today',
            center: '',
            right: 'title'
        };
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe(
            params => {
                // Get current child id
                this.currentId = params['id'];
                // Retrieve children statictis
                this.getChildren();
            }
        )
    }

    ngAfterViewInit() {
        const size = (window.screen.width);
        this.updateScheduleView(size);
    }

    // Get all children
    getChildren() {
        this.childrenServices.getChildren().subscribe(
            result => {
                this.children = result;
            },
            error => {

            }
        )
    }

    // End of Init
    // Retrieve student details
    getStudentDetail(from: string, to: string) {
        // Define requirement for getting student detail
        let query = {
            "filter": {
                "from_date": from,
                "to_date": to,
                "pupil_code": this.currentId
            },
            "page": 1,
            "max_per_page": 100
        };

        this.services.getBusAttendanceList(query).subscribe(
            result => {
                this.studentSchedule = result.data;
                this.addRowEmpty(this.studentSchedule);
                // Map student schedule to events
                this.events = _.map(this.studentSchedule, (val, key) => this.mapEvent(val))
            },
            error => {
            }
        )
    }

    addRowEmpty(data: any): void {
        let dateMissTime = data.filter((row: any) => {
            if (data.filter((rowFilter: any) => rowFilter.date === row.date).length === 1)
                return true;
            return false;
        });


        dateMissTime.forEach((element: any) => {
            if (element.expected_time !== "07:00:00") {
                // insert row temp for morning
                let newElement = {
                    pupil_code: "-1",
                    expected_time: "07:00:00",
                    date: element.date,
                    bus: {
                        code: "",
                        address: ""

                    }
                    , hostess: {
                        name: ""
                    }
                };
                data.push(newElement);
            }
        });
    }

    // Change child
    changeChild(event: any) {
        this.currentId = event
        this.getStudentDetail(this.startWeek, this.endWeek);
    }

    // Handle schedule template fullcalendar view render
    scheduleViewRenderEvent(e: any) {
        // Get start and end of current week as default
        this.startWeek = moment.utc(e.view.start).format('YYYY-MM-DD');
        this.endWeek = moment.utc(e.view.end).format('YYYY-MM-DD');

        // Retrieve current student detail                
        this.getStudentDetail(this.startWeek, this.endWeek);
    }

    // On Schedule View Render. When map student schedule to events array, we added des field which
    // contains all specific event info so that we can custome event's display
    onEventRender(event: any, element: any) {
        // console.log(event)
        // element.find(".fc-event-title").remove();
        // element.find(".fc-time").remove();


        element.addClass('custome-event-attendance');
        let start = moment(event.start).format('HH:mm');
        let present = '';
        let actual = '';
        let infoBySection = '';
        let isAbsent = false;
        let location = '';
        let presentDay = 'present-day';
        if (event.des.present === null) {
            present = '';
            element.addClass('none');
        }
        else {
            present = event.des.present ? 'Present' : 'Absent';
            element.addClass(event.des.present ? 'present' : 'absent');
            isAbsent = !event.des.present;
        }

        let isAfternoon = moment(start, 'HH:mm:ss').isAfter(moment('12:00:00', 'HH:mm:ss'));
        let isEndAfternoon = moment(start, 'HH:mm:ss').isAfter(moment('16:00:00', 'HH:mm:ss'));
        start = (isAfternoon ? 'Afternoon - ' + start : 'Morning');
        let inBusAt = '';
        if (isAfternoon) {
            inBusAt = '<b>Get in bus at: </b>' + (event.des && event.des.pick_up_time_afternoon ? event.des.pick_up_time_afternoon : '') + '</br>';
            if (isEndAfternoon)
                element.find(".fc-content").css("background-color", "red");
            else
                element.find(".fc-content").css("background-color", "blue");
        }

        // Replace event header
        element.find(".fc-time").html(start);

        if (moment(event.start).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
            let isTodayAfternoon = moment(new Date(), 'HH:mm:ss').isAfter(moment('12:00:00', 'HH:mm:ss'));
            if (isTodayAfternoon === isAfternoon) {
                location = '<a class="location" ><img class="location" src="./assets/theme/images/bus_school_icon.png" style="width:30px" ></a></br>';

            }
        }

        // Check afternoon bus
        // If afternoon
        if (event.des.pupil_code !== "-1") {
            if (moment(start, 'HH:mm:ss').isAfter(moment('12:00:00', 'HH:mm:ss'))) {
                actual = '<b>Actual Drop-off time: </b>' + (isAbsent ? 'None' : (event.des && event.des.actual_time ? event.des.actual_time.substring(5, 0) : ''));
                infoBySection = '<b>After School Class: </b>' + (event.des && event.des.asa_activities ? event.des.asa_activities : '');
            }
            else {
                actual = '<b>Actual Pick-up time: </b>' + (event.des && event.des.actual_time ? event.des.actual_time.substring(5, 0) : '');
                infoBySection = '<b>Pick-up time: </b>' + (event.des && event.des.expected_pickup_time ? event.des.expected_pickup_time.substring(5, 0) : '');
            }
            var new_description =
                '<div class="event-content">'
                + '<b>Bus Number: </b>' + event.des.bus.code + ' ' + location
                + '<img style="width:120px;display:block" class="avatar" src="/api/file/' + event.des.hostess.photo + '">'
                + '<b>Hostess: </b>' + event.des.hostess.name + '</br>'

                + '<b>Contact Number: </b>' + event.des.hostess.phone + '</br>'
                + infoBySection + '</br>'
                + '<b>Bus Attendance: </b> <span class="badge">' + present + '</span></br>'
                + inBusAt + ''
                + actual + '</br>'
                + '<b>Report: </b>' + (event.des.note !== null ? event.des.note : '') + '</br>'
                + '<b>Address: </b>' + event.des.address
                + '</div>'
                ;
        }
        else {
            element.hide();
        }


        element.append(new_description);
    }

    // Map Event
    mapEvent(event: any) {
        return {
            title: '',
            start: moment.utc(event.date).format('YYYY-MM-DD') + 'T' + event.expected_time,
            des: event
        };
    }

    // Handle events click event
    handleEventClick(event: any) {
        this.showScheduleDialog = true;
        this.selectedEvent = event;
        this.planningInfo = this.selectedEvent.calEvent.des;
        this.planningInfo.header = 'Bus location ' + this.planningInfo.bus.code;
    }

    showLocation() {
        this.isViewMap = !this.isViewMap;
    }

    @HostListener('document:click', ['$event'])
    private clickAnywhere(event: MouseEvent): void {
        if (event.srcElement.className == 'location') {
            this.showLocation();
        }
    }

    //change schedule view on resize screen
    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        let size = event.target.innerWidth;
        this.updateScheduleView(size);
    }

    updateScheduleView(size: number) {
        this.isShowSchedule = false;
        if (size <= 768)
            this.viewType = "basicDay";
        else
            this.viewType = "basicWeek";
        setTimeout(() => { this.isShowSchedule = true; }, 0)
    }
}



// WEBPACK FOOTER //
// ./src/bus/parent/bus-attendance/BusAttendanceComponent.ts